var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera-upload",on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_c('CameraIcon')]}),_c('input',{ref:"input",attrs:{"type":"file","capture":"camera","accept":"image/*"},on:{"change":_vm.change}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }